module.exports = __webpack_public_path__ + "img/icon_wechat_code.4d8d56ad.png";